export const MF_LOOKING = "/mf-looking-for-reps";
export const REPS_LOOKING = "/reps-looking-for-new-lines";